export function emptyRoomChecker(rooms) {
  const isEmpty = rooms.every(room => room.countFree === undefined);
  return isEmpty;
}